document.addEventListener("DOMContentLoaded", () => {

  // common jS

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.template-article .blog-post-content.rte p').forEach(function(p) {
        const content = p.innerHTML.replace(/<br\s*\/?>/gi, '').trim();
        if (content === '') {
            p.style.display = 'none';
        }
    });
  });

// SlierS 
  const heroSlider = new Swiper(".hero-slider", {
    centeredSlides: true,
    loop: false,
    speed: 1000,           
    grabCursor: true,
    spaceBetween: 10,

    autoplay: {            
      delay: 4500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },

    breakpoints: {
      480: { slidesPerView: 1, spaceBetween: 10 },
    },

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  //   buy slider
  const bueySlider = new Swiper(".buy-slider", {
    slidesPerView: 4,
    spaceBetween: 12,
    centeredSlides: false,
    grabCursor: true,
    loop: true,

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    breakpoints: {
      0: { slidesPerView: 1.2, spaceBetween: 10 },
      480: { slidesPerView: 2, spaceBetween: 10 },
      1024: { slidesPerView: 3, spaceBetween: 12 },
      1399: { slidesPerView: 4, spaceBetween: 12 },
    },
  });

  //   testimonial
  const testimonialSlider = new Swiper(".testimonial-slider", {
    slidesPerView: 1.1,
    spaceBetween: 12,
    grabCursor: true,
    loop: true,
       autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    pagination: {
      el: ".testimonial-slider .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      480: { slidesPerView: 1.5, spaceBetween: 14 },
      768: { slidesPerView: 2, spaceBetween: 16 },
      1024: { slidesPerView: 3, spaceBetween: 20 },
      1280: { slidesPerView: 4, spaceBetween: 20 },
    },
  });

  //   explore
  const exploreSlider = new Swiper(".explore-slider", {
    slidesPerView: 1.1,
    spaceBetween: 12,
    grabCursor: true,
    loop: true,
    pagination: {
      el: ".explore-slider .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      480: { slidesPerView: 1.2, spaceBetween: 14 },
      768: { slidesPerView: 2, spaceBetween: 16 },
      1025: { slidesPerView: 2.5, spaceBetween: 20 },
      1280: { slidesPerView: 3.5, spaceBetween: 20 },
    },
  });


  //   build slider

  const buildSlider = new Swiper(".build-slider", {
    slidesPerView: 1.1,
    spaceBetween: 16,
    grabCursor: true,
    loop: true,
    pagination: {
      el: ".build-slider .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      480: {
        slidesPerView: 1.5,
      },
      767: {
        slidesPerView: 1,
      },
    },
  });

  //   blog slider
  let blogSwiper = null;

  function initBlogSlider() {
    if (window.innerWidth <= 767) {
      if (!blogSwiper) {
        blogSwiper = new Swiper(".blog-slider", {
          slidesPerView: 1.1,
          spaceBetween: 16,
          grabCursor: true,
          pagination: {
            el: ".blog-slider .swiper-pagination",
            clickable: true,
          },
        });
      }
    } else {
      if (blogSwiper) {
        blogSwiper.destroy(true, true);
        blogSwiper = null;
      }
    }
  }

  initBlogSlider();
  window.addEventListener("resize", initBlogSlider);

  //   pdp slider start here

  // Highlight slider
  const highlightSlider = new Swiper(".Highlight-slider", {
    slidesPerView: 1.2,
    spaceBetween: 16,
    grabCursor: true,
    loop: false,
    breakpoints: {
      480: { slidesPerView: 1.5, spaceBetween: 16 },
      768: { slidesPerView: 1.6, spaceBetween: 20 },
    },
  });

  //   specification slider

  let extendSwiper = null;

  function initExtendSlider() {
    if (window.innerWidth <= 767) {
      if (!extendSwiper) {
        extendSwiper = new Swiper(".extend-slider", {
          slidesPerView: 2.2,
          spaceBetween: 12,
          grabCursor: true,
          loop: false,
        });
      }
    } else {
      if (extendSwiper) {
        extendSwiper.destroy(true, true);
        extendSwiper = null;
      }
    }
  }

  initExtendSlider();
  window.addEventListener("resize", initExtendSlider);

  //   access partial slider
  const partialSlider = new Swiper(".access-partial-slider", {
    slidesPerView: 1.2,
    spaceBetween: 16,
    grabCursor: true,
    loop: false,
    breakpoints: {
      480: { slidesPerView: 1.5, spaceBetween: 16 },
      768: { slidesPerView: 1.6, spaceBetween: 20 },
    },
  });

  //   unlock col slider
  const unlockcol = new Swiper(".unlock-col-slider", {
    slidesPerView: 1.1,
    spaceBetween: 16,
    grabCursor: true,
    breakpoints: {
      768: { slidesPerView: 2, spaceBetween: 20 },
    },
  });

  //   comparison slider

  const comparisonSlider = new Swiper(".comparison-slider", {
    slidesPerView: 1.8,
    spaceBetween: 15,
    grabCursor: true,
    allowTouchMove: true,
    breakpoints: {
      480: { slidesPerView: 2, allowTouchMove: true },
      768: { slidesPerView: 3, allowTouchMove: false },
    },
  });


    // smart card slider

  const smartCardSlider = new Swiper(".smart-card-slider", {
    slidesPerView: 1.1,
    spaceBetween: 16,
    grabCursor: true,
    breakpoints: {
      480: { slidesPerView: 1.5, spaceBetween: 16 },
      768: { slidesPerView: 3, spaceBetween: 20 },
      1024: { slidesPerView: 4, spaceBetween: 20 },
      1280: { slidesPerView: 4, spaceBetween: 24 },
    },
  });

  // door slider

  const doorSlider = new Swiper(".door-slider", {
    slidesPerView: 1.1,
    spaceBetween: 12,
    grabCursor: true,
    pagination: {
      el: ".door-slider .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      480: { slidesPerView: 1.5, spaceBetween: 14 },
      768: { slidesPerView: 2.2, spaceBetween: 16 },
      1024: { slidesPerView: 3, spaceBetween: 20 },
    },
  });

  // recent Serch SliDer 
  let recentSwiper = null;

function initRecentSlider() {
  if (window.innerWidth <= 991) {
    if (!recentSwiper) {
      recentSwiper = new Swiper(".recent-blogs", {
        slidesPerView: 1.3,
        spaceBetween: 16,
        grabCursor: true,
        loop: false,
        breakpoints: {
          480: { slidesPerView: 1.4 },
          768: { slidesPerView: 2.2 }
        }
      });
    }
  } else {
    if (recentSwiper) {
      recentSwiper.destroy(true, true);
      recentSwiper = null;
    }
  }
}

initRecentSlider();

document.addEventListener("DOMContentLoaded", initRecentSlider);
window.addEventListener("resize", initRecentSlider);

  const faqItems = document.querySelectorAll(".faq-item");

  if (faqItems.length) {
    faqItems[0].classList.add("active");

    faqItems.forEach((item) => {
      item.addEventListener("click", () => {
        const isActive = item.classList.contains("active");

        faqItems.forEach((faq) => {
          faq.classList.remove("active");
        });

        if (!isActive) {
          item.classList.add("active");
        }
      });
    });
  }

  document.querySelectorAll(".footer-accordion-trigger").forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const group = trigger.closest(".footer-accordion");
      group.classList.toggle("active");
    });
  });

  //   explore section
  const tabs = document.querySelectorAll(".explore-tab li");
  const tabBoxes = document.querySelectorAll(".explore-tab-box");
  const tabList = document.querySelector(".explore-tab");
  if (tabs.length) {
    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        tabs.forEach((t) => t.classList.remove("active"));
        tabBoxes.forEach((b) => b.classList.remove("active"));

        tab.classList.add("active");
        tabBoxes[index].classList.add("active");

        const tabWidth = tab.offsetWidth;
        const tabLeft = tab.offsetLeft;
        const listWidth = tabList.offsetWidth;
        const scrollTo = tabLeft - listWidth / 2 + tabWidth / 2;
        tabList.scrollTo({ left: scrollTo, behavior: "smooth" });
      });
    });
  }

  //   access mode js

  const accordionWrapper = document.querySelector(".access-accordion-wrapper");

  if (accordionWrapper) {
    const tabs = accordionWrapper.querySelectorAll(".access-accordion-tab");
    const images = accordionWrapper.querySelectorAll(".access-accordion-img");
    const prevBtn = accordionWrapper.querySelector(".access-acordion-btn.prev");
    const nextBtn = accordionWrapper.querySelector(".access-acordion-btn.next");

    let currentIndex = 0;

    function updateAccordion(index) {
      tabs.forEach((t) => t.classList.remove("active"));
      images.forEach((i) => i.classList.remove("active"));

      tabs[index].classList.add("active");
      if (images[index]) images[index].classList.add("active");

      prevBtn.disabled = index === 0;
      nextBtn.disabled = index === tabs.length - 1;

      currentIndex = index;
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => updateAccordion(index));
    });

    prevBtn.addEventListener("click", () => {
      if (currentIndex > 0) updateAccordion(currentIndex - 1);
    });

    nextBtn.addEventListener("click", () => {
      if (currentIndex < tabs.length - 1) updateAccordion(currentIndex + 1);
    });

    updateAccordion(0);
  }

if (document.querySelectorAll(".user-manual").length) {
    document.querySelectorAll(".user-manual").forEach((manual) => {
        manual.addEventListener("click", function (e) {
            e.stopPropagation();
        });
    });
}


//  cArrer 
 if (document.querySelector(".value-grid-slider")) {
            let valueGridSwiper = null;

            function initValueGridSlider() {
                if (window.innerWidth <= 991) {
                    if (!valueGridSwiper) {
                        valueGridSwiper = new Swiper(".value-grid-slider", {
                            slidesPerView: 1.2,
                            spaceBetween: 12,
                            speed: 600,
                            breakpoints: {
                                576: { slidesPerView: 2, spaceBetween: 12 },
                            },
                        });
                    }
                } else {
                    if (valueGridSwiper) {
                        valueGridSwiper.destroy(true, true);
                        valueGridSwiper = null;
                    }
                }
            }

            initValueGridSlider();

            let resizeTimer;
            window.addEventListener("resize", function () {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(initValueGridSlider, 200);
            });
        }

        if (document.querySelectorAll(".feature-table-row-merged .featured-job-table-data:first-child .featured-job-para").length) {
            document.querySelectorAll(".feature-table-row-merged .featured-job-table-data:first-child .featured-job-para").forEach(function (el) {
                el.textContent = el.textContent.split(",")[0].trim();
            });
        }


        
const drawer = document.querySelector('.compare-drawer');

if (drawer) {
  const isMobile = () => window.innerWidth <= 768;

  const getOffset = () => isMobile() ? 55 : 44;

  const originalTop = parseInt(getComputedStyle(drawer).top) || 108;

  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY > 50;
    drawer.style.transition = 'top 0.3s ease';
    drawer.style.top = scrolled ? (originalTop - getOffset()) + 'px' : originalTop + 'px';
  });

  // Recalculate on resize
  window.addEventListener('resize', () => {
    const scrolled = window.scrollY > 50;
    drawer.style.top = scrolled ? (originalTop - getOffset()) + 'px' : originalTop + 'px';
  });
}

// scroll JS 
document.querySelectorAll(".product-information__grid .tags-wrapper").forEach((slider) => {
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener("mousedown", (e) => {
    isDown = true;
    slider.classList.add("dragging");
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  document.addEventListener("mouseup", () => {
    isDown = false;
    slider.classList.remove("dragging");
  });

  slider.addEventListener("mouseleave", () => {
    isDown = false;
    slider.classList.remove("dragging");
  });

  slider.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2;
    slider.scrollLeft = scrollLeft - walk;
  });
});
});
